import React from "react";
import { Icon } from "../../../components";
import styles from "./portal_booking_space_details.module.css";

interface PortalBookingSpaceDetailsProps {
  imgUrl: string;
  location: string;
  bookingDate?: string | JSX.Element;
  capacity: number;
}

export function PortalBookingSpaceDetails({
  imgUrl,
  location,
  bookingDate,
  capacity,
}: PortalBookingSpaceDetailsProps) {
  return (
    <div className={styles.spaceDetailsComponent}>
      <div>
        <img className={styles.spaceImage} src={imgUrl} alt="day pass" />
      </div>
      <div className={styles.spaceDetailsWrapper}>
        <div className={styles.detailWrapper}>
          <Icon name="location" />
          <div>{location}</div>
        </div>
        {bookingDate && (
          <div className={styles.detailWrapper}>
            <Icon name="calendar" />
            <div>{bookingDate}</div>
          </div>
        )}
        <div className={styles.detailWrapper}>
          <Icon name={capacity > 1 ? "people" : "user"} />
          <div>{capacity > 1 ? `Up to ${capacity} people` : "1 Guest"}</div>
        </div>
      </div>
    </div>
  );
}
